import React from "react";
import { Grid, Typography } from "@mui/material";
import { Container } from "./styled";
import EducationBanner from "./EducationBanner";
import CourseCard from "../Education/CourseCard";
import { Theme } from "@mui/material";
import {
    Course,
    CAIRO_0_EDUCATION_COURSES,
    CAIRO_1_EDUCATION_COURSES,
} from "../EducationCourse/eduConfig";
import { useTheme } from "@mui/material";
import { CustomThemeOptions } from "@js/components/CustomColors/Colors";

const Education = () => {
    const theme: CustomThemeOptions & Theme = useTheme();

    const renderCourses = (title: string, courses: Course[]) => {
        return (
            <Grid container>
                <Grid
                    item
                    sx={{
                        marginTop: "25px",
                    }}
                >
                    <Typography fontSize={"1.25rem"} fontWeight={"bold"} my={1}>
                        {title}:
                    </Typography>
                    <Grid item sx={{ display: "flex", alignItems: "center" }}>
                        {courses.map((course) => {
                            let numModules = 0;
                            for (let moduleGroup of course.moduleGroup) {
                                numModules += moduleGroup.modules.length;
                            }
                            return (
                                <CourseCard
                                    key={course.courseName}
                                    name={course.title}
                                    imgSrc={course.imgSrc}
                                    numModules={numModules}
                                    path={course.path}
                                    colorTheme={
                                        course.borderColorStyle
                                            ? course.borderColorStyle
                                                  .borderColor
                                            : theme.palette.courseCard.main
                                    }
                                />
                            );
                        })}
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    return (
        <Container>
            <Typography>Courses</Typography>
            <EducationBanner
                bannerTitle={"Learn to code Cairo 1.0 on Starknet!"}
                bannerSubtext={
                    "Learn Cairo 1.0 and Cairo 0 with our dynamic, interactive tutorials that run completely in your browser, no setup required! Earn and mint Badge NFTs upon completion of each module!"
                }
                hasBannerImage={true}
            />
            {renderCourses("Cairo 1.0 Courses", CAIRO_1_EDUCATION_COURSES)}
            {renderCourses("Cairo 0 Courses", CAIRO_0_EDUCATION_COURSES)}
        </Container>
    );
};

export default Education;
